import React, { useContext } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../libs/Context';
import { useSelector } from 'react-redux';
import AccessDenied from '../../assets/NoDataImages/accessDenied.svg';

function DeclinedAccess()
{
	const navigation = useNavigate();
	const { language } = useContext(LanguageContext);
	const session = useSelector((state) => state?.mysession?.session);
	const path = window.location.pathname;

	function openPageNotfnd()
	{
		if ([ '/contractManagement', '/productWarranty' ].includes(path))// to stop  showing until the entire userData keys are set
		{
			return Boolean(Object.keys(session)?.length > 14);
		}
		else { return true; }
	}

	const handleNavigate = () =>
	{
		if (session?.userId)
		{
			navigation(-1);
		}
		else
		{
			navigation('/');
		}
	};

	return (
		<>
			{openPageNotfnd() &&
			<div className='flexCol justifyCntr alignCntr fullVirtualHeight'>
				<div className='flexInline alignCntr justifyCntr'>
					<span className='icon-accessDenied--1 nodatafont'><span className='path1' /><span className='path2' /><span className='path3' /><span className='path4' /><span className='path5' /><span className='path6' /><span className='path7' /><span className='path8' /><span className='path9' /><span className='path10' /><span className='path11' /><span className='path12' /><span className='path13' /><span className='path14' /><span className='path15' /><span className='path16' /></span>			</div>
				<div className='flexCol alignCntr pdngSM'>
					<h3 className='textCntr mrgnBtmSM'>{language?.accessDenied}</h3>
					<span className='textCntr'>
						<p>{language?.noAccess}</p>
						<p>{language?.contactAdmin}</p>
					</span>
					<button
						onKeyUp={(e) => e.key === 'Enter' && handleNavigate()}
						className='flexInline pdngVMD'
						onClick={handleNavigate}
					>
						<Button disableElevation disableRipple className='link' variant='outlined'>{language?.goBack}</Button>
					</button>
				</div>
			</div>}
		</>
	);
}
export default DeclinedAccess;
